<h1>Welcome to Gamebit!</h1>

<div style="text-align:center;float:left" #rendererContainer>
</div>

<!-- <h1>Welcome to Gamebit!</h1>


<p>I am a Progressive Web App (PWA) built with Angular and Firebase.</p>

<h2>Have Questions?</h2>

<p>
  <i class="fa fa-slack fa-lg"></i> Let's talk on the <a target="blank" href="https://join.slack.com/t/angularfirebase/shared_invite/enQtMjU2OTU5OTMyODM3LWU4YTZiMGFhZjJhYmEwYzI1MWFmYTgyMWRmOTI5NWZjYWE3NTMwZjFmNWMwZGI1MmMzODQ3OTFlZjFkMjc5N2Y">
  Angular Firebase Developers Slack Team
</a>
</p>

<h2>Free Open Source Screencasts</h2>

<p>
  <i class="fa fa-youtube fa-lg"></i>
  Subscribe to the <a href="https://www.youtube.com/channel/UCsBjURrPoezykLs9EqgamOA">AngularFirebase YouTube Channel</a> for weekly lessons.
</p> -->



// WEBPACK FOOTER //
// ./src/app/ui/readme-page/readme-page.component.html